/**
 * @module @/rules/booking_rules
 * @author lwc
 * @description 订舱部分表单的校验规则.
 * @date 2020年3月19日
 * */

import { validateWordFn } from './validateWordFn'

const bookingFormRules = {
  orderNo:[{validator: validateWordFn.bind(50), trigger: 'blur'}],
  customerbusiness_num: [
    {required: true, message: '请输入客户业务编号', trigger: 'blur'},
    {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'change'}
  ],
  custBizNo: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },
    {validator: validateWordFn.bind(1000), trigger: 'blur'}],
  carrierName: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },
    {validator: validateWordFn.bind(50), trigger: 'blur'}],
  mblNo: [
    {
      validator: notChineseCheck,
      trigger: 'blur'
    },
    {validator: validateWordFn.bind(50), trigger: 'blur'}
  ],
  agreementNo: [
    {
      validator: notChineseCheck,
      trigger: 'blur'
    },
    {validator: validateWordFn.bind(20), trigger: 'blur'}
  ],
  nameAccount:[{validator: validateWordFn.bind(20), trigger: 'blur'}],
  settleOfficeName: [{
    required: false,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(20), trigger: 'blur'}],
  mblPaymentType: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(20), trigger: 'blur'}],
  // mblPaymentPlace: [{validator: validateWordFn.bind(20), trigger: 'blur'}],
  hblTransportTermFrom: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  hblTransportTermTo: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  mblTransportTermFrom: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(20), trigger: 'blur'}],
  mblTransportTermTo: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(20), trigger: 'blur'}],
  issueMode: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(10), trigger: 'blur'}],
  placeOfIssueName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  noOfOriginal: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(10), trigger: 'blur'}],
  noOfCopy: [{validator: validateWordFn.bind(10), trigger: 'blur'}],
  custContact: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(30), trigger: 'blur'}],
  // custContactTel: [{
  //   required: true,
  //   message: "不能为空",
  //   trigger: ['blur', 'change']
  // },{validator: validateWordFn.bind(20), trigger: 'blur'}],
  custEmail: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(50), trigger: 'blur'}],
  polName: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{validator: validateWordFn.bind(50), trigger: 'blur'}],
  carrierSales:[{validator: validateWordFn.bind(50), trigger: 'blur'}],
  csName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  csEmail: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  csTel: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  mobile: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  vesselNameEn: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  voyage: [{validator: validateWordFn.bind(20), trigger: 'blur'}],
  etd: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  terminalName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  bargeVesselName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  bargeVoyage: [{validator: validateWordFn.bind(20), trigger: 'blur'}],
  bargeTerminalName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  porName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  porCode: [{validator: validateWordFn.bind(20), trigger: 'blur'}],
  potName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  podName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  placeOfDeliveryName: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  placeOfDeliveryCode: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  bargeTransitPortCode: [{validator: validateWordFn.bind(50), trigger: 'blur'}],
  freeStorage: [{validator: validateWordFn.bind(15), trigger: 'blur'}],
  freeOfDetention: [{validator: validateWordFn.bind(15), trigger: 'blur'}],
  freeDays: [{validator: validateWordFn.bind(15), trigger: 'blur'}],
  custContactTel: [{validator: validateWordFn.bind(100), trigger: 'blur'}],
  custContactEmail: [{validator: validateWordFn.bind(100), trigger: 'blur'}],
};

const ebPartyFormRules = {
  "ebPartyRSH.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartyRSH.partyDescription": [{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],
  "ebPartyRCN.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartyRCN.partyDescription": [{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],
  "ebPartyRNT.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartyRNT.partyDescription": [{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],

  "ebPartySH.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartySH.partyDescription": [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],
  "ebPartyCN.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartyCN.partyDescription": [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],
  "ebPartyNT.partyMainName": [{
    validator: validateWordFn.bind(100), trigger: 'blur'
  }],
  "ebPartyNT.partyDescription": [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(1000), trigger: 'blur'
  }],
};

const ebPartySHDialogFormRules = {
  partyMainName: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }, {
    min: 0,
    max: 200,
    message: '长度不能超过200',
    trigger: ['blur', 'change']
  }],
  partyAddress: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(200), trigger: 'blur'
  }],
  countryName: [{
    validator: validateWordFn.bind(50), trigger: 'blur'
  }],
  areaName:[{ validator: validateWordFn.bind(50), trigger: 'blur'}],
  postCode: [{
    min: 0,
    max: 50,
    message: '长度不能超过50',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  email: [{
    min: 0,
    max: 50,
    message: '长度不能超过50',
    trigger: ['blur', 'change']
  }],
  contactPerson: [{
    min: 0,
    max: 30,
    message: '长度不能超过30',
    trigger: ['blur', 'change']
  }],
  mobilePhone: [{
    min: 0,
    max: 30,
    message: '长度不能超过30',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  tel: [{
    min: 0,
    max: 50,
    message: '长度不能超过50',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  fax: [{
    min: 0,
    max: 50,
    message: '长度不能超过50',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  taxNo: [{
    min: 0,
    max: 50,
    message: '长度不能超过50',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  aeoNo: [{
    min: 0,
    max: 20,
    message: '长度不能超过20',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
  carrierCode: [{
    min: 0,
    max: 20,
    message: '长度不能超过20',
    trigger: ['blur', 'change']
  }, {
    validator: notChineseCheck,
    trigger: 'blur'
  }],
}

const cargoInfoFormRules = {
  cargoDescription: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  marks: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  noOfPackage: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  packageTypeName: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
}
const cargoStatisticsFormRules = {
  hsCode:[{validator: validateWordFn.bind(10), trigger: 'blur'}],
  flashPoint:[{validator: validateWordFn.bind(10), trigger: 'blur'}],
  netWeight:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  dangerTechnicalDesc:[{validator: validateWordFn.bind(200), trigger: 'blur'}],
  urgentContractCompany:[{validator: validateWordFn.bind(50), trigger: 'blur'}],
  warehouseName:[{validator: validateWordFn.bind(50), trigger: 'blur'}],
  warehouseAddress:[{validator: validateWordFn.bind(200), trigger: 'blur'}],
  warehouseContactTel:[{validator: validateWordFn.bind(20), trigger: 'blur'}],
  warehouseContact:[{validator: validateWordFn.bind(20), trigger: 'blur'}],
  warehouseContactFax:[{validator: validateWordFn.bind(20), trigger: 'blur'}],
  temperatureMin:[{validator: validateWordFn.bind(10), trigger: 'blur'}],
  temperatureMax:[{validator: validateWordFn.bind(10), trigger: 'blur'}],
  bulkyCargoRemark:[{validator: validateWordFn.bind(500), trigger: 'blur'}],
  overWeight:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  overHigh:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  overFront:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  overBehind:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  overLeft:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  overRight:[{validator: validateWordFn.bind(12), trigger: 'blur'}],
  cargoDescription: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(2000), trigger: 'blur'
  }],
  commodity: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(2000), trigger: 'blur'
  }],
  noOfPackage: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  packageTypeName: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  marks: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: notChineseCheck,
    trigger: 'blur'
  },{
    validator: validateWordFn.bind(2000), trigger: 'blur'
  }],
  grossWeight: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  cube: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(10), trigger: 'blur'
  }],
  unNo: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(10), trigger: 'blur'
  }],
  hazardClass: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
  temperature: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(12), trigger: 'blur'
  }],
  temperatureUnit: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(12), trigger: 'blur'
  }],
  airVentsSet: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(12), trigger: 'blur'
  }],
  length: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{
    validator: validateWordFn.bind(12), trigger: 'blur'
  }],
  width: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{ validator: validateWordFn.bind(12), trigger: 'blur' }],
  height: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  },{ validator: validateWordFn.bind(12), trigger: 'blur' }],
  noOfPackages: [{
    required: true,
    message: "不能为空",
    trigger: ['blur', 'change']
  }],
}

function notChineseCheck(rule, value, callback) {
  if (value) {
    if (/[\u4E00-\u9FA5]/g.test(value)) {
      callback(new Error('不能输入中文'))
    } else {
      callback()
    }
  }
  callback()
}


export {
  bookingFormRules, ebPartyFormRules, ebPartySHDialogFormRules, cargoInfoFormRules, cargoStatisticsFormRules
}
